// Frequent words and word pairs in discard reasons — a secondary, unstructured view
// next to the reason taxonomy (discardReasons.js).

const STOPWORDS = new Set([
  "the","a","an","and","or","but","if","of","to","in","on","for","is","it","this","that",
  "we","i","you","they","them","with","at","be","are","was","were","not","no","so","do",
  "does","did","has","have","had","as","by","from","its","our","their","than","then",
  "there","here","which","who","what","when","where","how","why","into","out","up","down",
  "about","over","just","also","very","more","most","some","any","all","other","because",
  "would","could","should","can","will","may","might","one","two","too","still","yet",
  "issue","issues","page","site","website","find","found","needs","need","like","really",
]);

export function topPhrases(discards, limit = 15) {
  const counts = {};
  for (const d of discards || []) {
    const reason = (d.discard_reason || "")
      .toLowerCase()
      .replace(/[‘’ʼ]/g, "'")
      .replace(/[“”]/g, '"');
    if (!reason) continue;
    const tokens = (reason.match(/[a-z][a-z'-]*/g) || []).filter((t) => t.length >= 2 && !STOPWORDS.has(t));
    for (const t of tokens) counts[t] = (counts[t] || 0) + 1;
    for (let i = 0; i < tokens.length - 1; i++) {
      const bg = `${tokens[i]} ${tokens[i + 1]}`;
      counts[bg] = (counts[bg] || 0) + 1;
    }
  }
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, limit);
}
